import { createGlobalStyle } from "styled-components";

// Intercom (banners/launcher) sits at z-index ~2147483000, above everything.
// Keep it under MUI modals while one is open. MUI drawers default to 1200
// (only Overlay.jsx/CenteredOverlay.tsx force 1300), so use 1100 to stay
// below both, since equal z-index would fall back to DOM order.
export const IntercomBelowModalsGlobalStyle = createGlobalStyle`
  body:has(.MuiModal-root:not(.MuiModal-hidden)) #intercom-container,
  body:has(.MuiModal-root:not(.MuiModal-hidden)) .intercom-lightweight-app,
  body:has(.MuiModal-root:not(.MuiModal-hidden)) iframe[name="intercom-banner-frame"] {
    z-index: 1100 !important;
  }
`;
